import { render, staticRenderFns } from "./distributorCampaigns.vue?vue&type=template&id=25e0e72a&scoped=true&"
import script from "./distributorCampaigns.vue?vue&type=script&lang=js&"
export * from "./distributorCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./distributorCampaigns.vue?vue&type=style&index=0&id=25e0e72a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e0e72a",
  null
  
)

export default component.exports